import { render } from "./ImpressumPage.vue?vue&type=template&id=5b6df54d&scoped=true"
import script from "./ImpressumPage.vue?vue&type=script&lang=js"
export * from "./ImpressumPage.vue?vue&type=script&lang=js"

import "./ImpressumPage.vue?vue&type=style&index=0&id=5b6df54d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6df54d"]])

export default __exports__